// Smooth-Scroll zu einem Hash (#id). Wird vom SiteLayout genutzt,
// damit Anker-Links auch nach Route-Wechsel funktionieren.

export function scrollToHash(hash, { behavior = 'smooth', offset = 80 } = {}) {
  if (!hash) return false;
  const id = hash.startsWith('#') ? hash.slice(1) : hash;
  const el = document.getElementById(id);
  if (!el) return false;

  const top = el.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top, behavior });
  return true;
}
